import React, { useState } from 'react';
import { getIn18Text } from 'api';
import { Modal, Checkbox } from 'antd';
import './index.scss';
const NoticeModal = ({ visible, onClose }) => {
    const [isNotice, setIsNotice] = useState(false);
    const onChange = e => {
        setIsNotice(e.target.checked);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { closable: false, visible: visible, width: 400, maskClosable: false, wrapClassName: "notice-modal", onOk: () => {
                onClose(isNotice, true);
            }, onCancel: () => {
                onClose(isNotice, false);
            }, okText: getIn18Text('XUYAO'), cancelText: getIn18Text('BUXUYAO') },
            React.createElement("div", { className: "send-info" },
                React.createElement("div", { className: "send-info-icon" }),
                React.createElement("div", { className: "send-info-text" }, getIn18Text('YIDIANZAN\uFF0CJIAN'))),
            React.createElement("div", { className: "send-check" },
                React.createElement(Checkbox, { onChange: onChange }, getIn18Text('JIZHUXUANXIANG'))))));
};
export default NoticeModal;
